import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_XDPS = '/xdps';

export const GET_XDPS = 'GET_XDPS';
export const GET_XDPS_PENDING = 'GET_XDPS_PENDING';
export const GET_XDPS_FULFILLED = 'GET_XDPS_FULFILLED';
export const GET_XDPS_REJECTED = 'GET_XDPS_REJECTED';

export const GET_XDP = 'GET_XDP';
export const GET_XDP_PENDING = 'GET_XDP_PENDING';
export const GET_XDP_FULFILLED = 'GET_XDP_FULFILLED';
export const GET_XDP_REJECTED = 'GET_XDP_REJECTED';

export const CREATE_XDP = 'CREATE_XDP';
export const CREATE_XDP_PENDING = 'CREATE_XDP_PENDING';
export const CREATE_XDP_FULFILLED = 'CREATE_XDP_FULFILLED';
export const CREATE_XDP_REJECTED = 'CREATE_XDP_REJECTED';
export const UPDATE_XDP = 'UPDATE_XDP';
export const UPDATE_XDP_PENDING = 'UPDATE_XDP_PENDING';
export const UPDATE_XDP_FULFILLED = 'UPDATE_XDP_FULFILLED';
export const UPDATE_XDP_REJECTED = 'UPDATE_XDP_REJECTED';
export const DELETE_XDP = 'DELETE_XDP';
export const DELETE_XDP_PENDING = 'DELETE_XDP_PENDING';
export const DELETE_XDP_FULFILLED = 'DELETE_XDP_FULFILLED';
export const DELETE_XDP_REJECTED = 'DELETE_XDP_REJECTED';

export const SELECT_XDP = 'SELECT_XDP';
export const GO_TO_XDP_CREATE = 'GO_TO_XDP_CREATE';
export const GO_TO_XDP_EDIT = 'GO_TO_XDP_EDIT';
export const GO_TO_XDP_VIEW = 'GO_TO_XDP_VIEW';
export const GO_TO_XDP_COPY = 'GO_TO_XDP_COPY';
export const GO_TO_XDP_LIST = 'GO_TO_XDP_LIST';

export enum XdpMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export enum XdpPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface Xdp {
  id: string
  inPortEnd: string
  inPortStart: string
  insideNat: boolean | string
  ipAddr: string
  ipduId: string
  outPortEnd: string
  outPortStart: string
  port: string
  state: string
  switchTech: string
  nodeName: string
  access?: string,
  group?: string
  owner?: string,
  listenip?: string,
}

export interface XdpServerResponse {
  id: string
  INPORTEND: string
  INPORTSTART:string
  INSIDENAT: string
  IPADDR:string
  PORT: string
  IPDUID: string
  LISTENIP?: string
  OUTPORTEND: string
  OUTPORTSTART: string
  NODENAME: string
  STATE:string
  ACCESS?: string
  GROUP?:string
  OWNER?: string
  SWITCHTECH?: string
}

export interface XdpState {
  entities: Xdp[]
  select: Xdp[]
  single: Xdp | null
}

export interface GetXdpAction extends AnyAction {
  type: typeof GET_XDPS
  payload: AxiosPromise<ServerResponse<Xdp | XdpServerResponse>>
}

export interface GetXdpPendingAction extends AnyAction {
  type: typeof GET_XDPS_PENDING
  payload: AxiosResponse<ServerResponse<Xdp>>
}
export interface GetXdpFulfilledAction extends AnyAction {
  type: typeof GET_XDPS_FULFILLED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface GetXdpRejectedAction extends AnyAction {
  type: typeof GET_XDPS_REJECTED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface GetSingleXdpAction extends AnyAction {
  type: typeof GET_XDP
  payload: AxiosPromise<ServerResponse<Xdp | XdpServerResponse>>
}

export interface GetSingleXdpPendingAction extends AnyAction {
  type: typeof GET_XDP_PENDING
  payload: AxiosResponse<ServerResponse<Xdp>>
}
export interface GetSingleXdpFulfilledAction extends AnyAction {
  type: typeof GET_XDP_FULFILLED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface GetSingleXdpRejectedAction extends AnyAction {
  type: typeof GET_XDP_REJECTED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface CreateXdpThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface CreateXdpAction extends AnyAction {
  type: typeof CREATE_XDP
  payload: AxiosPromise<ServerResponse<Xdp | XdpServerResponse>>
}

export interface CreateXdpFulfilledAction extends AnyAction {
  type: typeof CREATE_XDP_FULFILLED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface CreateXdpRejectedAction extends AnyAction {
  type: typeof CREATE_XDP_REJECTED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface UpdateXdpThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface UpdateXdpAction extends AnyAction {
  type: typeof UPDATE_XDP
  payload: AxiosPromise<ServerResponse<Xdp | XdpServerResponse>>
}

export interface UpdateXdpFulfilledAction extends AnyAction {
  type: typeof UPDATE_XDP_FULFILLED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface UpdateXdpRejectedAction extends AnyAction {
  type: typeof UPDATE_XDP_REJECTED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface DeleteXdpThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface DeleteXdpAction extends AnyAction {
  type: typeof DELETE_XDP
  payload: AxiosPromise<ServerResponse<Xdp | XdpServerResponse>>
}

export interface DeleteXdpFulfilledAction extends AnyAction {
  type: typeof DELETE_XDP_FULFILLED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface DeleteXdpRejectedAction extends AnyAction {
  type: typeof DELETE_XDP_REJECTED
  payload: AxiosResponse<ServerResponse<Xdp>>
}

export interface SelectXdp extends AnyAction {
  type: typeof SELECT_XDP
  payload: Xdp[]
}

export type XdpActionTypes =
  GetXdpAction |
  GetXdpPendingAction |
  GetXdpFulfilledAction |
  GetXdpRejectedAction |
  GetSingleXdpAction |
  GetSingleXdpPendingAction |
  GetSingleXdpFulfilledAction |
  GetSingleXdpRejectedAction |
  DeleteXdpAction |
  DeleteXdpFulfilledAction |
  DeleteXdpRejectedAction |
  CreateXdpAction |
  CreateXdpFulfilledAction |
  CreateXdpRejectedAction |
  UpdateXdpAction |
  UpdateXdpFulfilledAction |
  UpdateXdpRejectedAction |
  SelectXdp;
